// @ts-nocheck
// Legacy, and only in the type-check program because an FSD slice imports it through
// one of the two sanctioned exceptions. Its own types were never checked and fixing
// them means guessing at API semantics — out of scope for the FSD migration. Drop this
// line when the file is migrated.
/**
 * Simple object check.
 * @param item
 * @returns {boolean}
 */
export function isObject(item: any) {
  return item && typeof item === 'object' && !Array.isArray(item)
}

/**
 * Deep merge two objects.
 * @param target
 * @param ...sources
 */
export function deepMerge(target: any, ...sources: any): object {
  if (!sources.length) return target
  const source = sources.shift()

  if (isObject(target) && isObject(source)) {
    for (const key in source) {
      if (isObject(source[key])) {
        if (!target[key]) Object.assign(target, { [key]: {} })
        deepMerge(target[key], source[key])
      } else {
        Object.assign(target, { [key]: source[key] })
      }
    }
  }

  return deepMerge(target, ...sources)
}

export function objectMap(obj: object, fn: (x: any) => void): object {
  return Object.fromEntries(
    Object.entries(obj).map(([k, v], i) => [k, fn(v, k, i)])
  )
}

export function transformKeys(obj: object, fn: (x: any) => void): object {
  return Object.keys(obj).reduce((acc, key) => {
    acc[fn(key)] = obj[key]
    return acc
  }, {})
}

export const isEqual = (object1: any, object2: any) => {
  return JSON.stringify(object1) === JSON.stringify(object2)
}

export const isEmpty = (obj: any): boolean => {
  return isObject(obj) && Object.keys(obj).length === 0
}
